import { Component } from '@angular/core';

@Component({
  selector: 'app-sign-instruction',
  standalone: true,
  imports: [],
  templateUrl: './sign-instruction.component.html',
  styleUrl: './sign-instruction.component.scss'
})
export class SignInstructionComponent {

}
